export default "__VITE_ASSET__CeKfGllv__"